import { useQuery } from '@tanstack/react-query'
import { clientApi } from '@/lib/api-client'

export function useOnboardingStatus(clientId: string | null | undefined) {
  return useQuery({
    queryKey: ['client', 'status', clientId],
    queryFn: () => clientApi.getStatus(clientId!),
    enabled: Boolean(clientId),
  })
}
